<template>
    <div class="steppers">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'Stepper',
    props: {
        active: Number,
        finishStatus: {
            type: String,
            default: 'finish'
        },
        processStatus: {
            type: String,
            default: 'process'
        },
    },
    data() {
        return {
            steps: []
        }
    },
    watch: {
        active(newVal, oldVal) {
            this.$emit('change', newVal, oldVal);
        },
        steps(steps) {
            steps.forEach((child, index) => {
                child.index = index
            });
        }

    }
}
</script>

<style scoped>
    .steppers {
        height: 90px;
        display: flex;
        justify-content: center;
        /* align-items: center; */
        margin: 0 auto;
    }
</style>